// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"59fa825e","425":"6ec33e2d","510":"c6cf6d8b","532":"414d80e7","633":"4f99995e","634":"c314c186","922":"8282e291","937":"56b119be","972":"e7e49aa6"}[chunkId] + ".chunk.js";
};